module.exports = __webpack_public_path__ + "assets/images/amira_review_student_default.3e9bac2a49cae94d25c03b3015700bb0.svg";